import { readBoundedJSON } from "./http";
import { isShareToken, parseSharedCard, trustedAPIBaseURL, type SharedCard } from "./types";

const configuredAPIBaseURL = import.meta.env.VITE_API_BASE_URL as string | undefined;
const API_BASE_URL = configuredAPIBaseURL === undefined
  ? "https://api.lorefoil.kifferliu.com"
  : trustedAPIBaseURL(configuredAPIBaseURL, import.meta.env.DEV);

export async function getSharedCard(token: string): Promise<SharedCard> {
  if (!API_BASE_URL || !isShareToken(token)) throw new Error("INVALID_RESPONSE");
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 20_000);
  try {
    const response = await fetch(`${API_BASE_URL}/v1/shares/${encodeURIComponent(token)}`, {
      headers: { Accept: "application/json" },
      redirect: "error",
      signal: controller.signal,
    });
    if (!response.ok) {
      try { await response.body?.cancel(); } catch { /* best effort */ }
      throw new Error(response.status === 404 ? "NOT_FOUND" : "UNAVAILABLE");
    }
    const card = parseSharedCard(await readBoundedJSON(response), token);
    if (!card) throw new Error("INVALID_RESPONSE");
    return card;
  } finally {
    window.clearTimeout(timeout);
  }
}

export function sharedAssetURL(token: string, assetId: string): string {
  if (!API_BASE_URL || !isShareToken(token)
      || !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu.test(assetId)) return "";
  return `${API_BASE_URL}/v1/shares/${encodeURIComponent(token)}/assets/${encodeURIComponent(assetId)}`;
}
